/**
 * Spot Processing API Client
 *
 * Frontend wrapper for spot processing workflow configuration
 */

import axios from '@/axios'

export default {
  /**
   * Get spot processing config for current organization
   */
  async getConfig() {
    try {
      const response = await axios.get('/api/spot-processing/config')
      return response.data
    } catch (error) {
      // Config may not exist yet, return empty
      if (error.response?.status === 404) {
        return { configured: false }
      }
      console.error('Get spot processing config error:', error)
      throw error
    }
  },

  /**
   * Update workflow configuration (input/output storage, encoding preset)
   */
  async updateWorkflowConfig(data) {
    try {
      const response = await axios.put('/api/spot-processing/config', data)
      return response.data
    } catch (error) {
      console.error('Update workflow config error:', error)
      throw error
    }
  },

  /**
   * Get full spot processing status
   */
  async getStatus() {
    try {
      const response = await axios.get('/api/spot-processing/status')
      return response.data
    } catch (error) {
      console.error('Get spot processing status error:', error)
      throw error
    }
  },

  /**
   * Validate spot processing configuration
   */
  async validateConfig() {
    try {
      const response = await axios.post('/api/spot-processing/validate')
      return response.data
    } catch (error) {
      console.error('Validate config error:', error)
      throw error
    }
  }
}
